import { render, staticRenderFns } from "./InfoOfMovieModal.vue?vue&type=template&id=3c83fa5c&scoped=true&"
import script from "./InfoOfMovieModal.vue?vue&type=script&lang=js&"
export * from "./InfoOfMovieModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c83fa5c",
  null
  
)

export default component.exports